import React from "react";
import Lottie from "lottie-react";
import animationData from "../../../animation/mapanimation.json";


const HomeMainSection = () => {
  return (
    <div className="homeMainSection">
      <div className="homeMainSection__container">
        <div className="homeMainSection__left">
          <div className="homeMainSection__heading">
            Trusted By Travelers, <br /> Loved By Nomads
          </div>
          <div className="homeMainSection__para">
            VisaFu makes tourist e-visas simple and stress-free, helping you
            travel without worries. Whether it’s a vacation or an adventure
            abroad, we ensure quick, smooth processing with expert support.
            Start your journey confidently with VisaFu!
          </div>
        </div>
        <div className="homeMainSection__right">
          <div>
            <Lottie
              animationData={animationData}
              loop={true}
              autoplay={true}
              style={{ height: 350 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeMainSection;
